import { Container, Row } from "reactstrap";
import Header from "components/Headers/Header.js";
import { createMuiTheme, MuiThemeProvider } from "@material-ui/core/styles";
import MUIDataTable from "mui-datatables";
import Chip from "@material-ui/core/Chip";
import { useHistory } from "react-router";
import { useSelector } from "react-redux";

const PendingTable = () => {
  const { role, name } = JSON.parse(window.sessionStorage.getItem("user"));
  const { patients } = useSelector((state) => state.patients || []);

  const getMuiTheme = () =>
    createMuiTheme({
      overrides: {
        MUIDataTableToolbar: {
          filterPaper: {
            width: "450px",
          },
        },
      },
    });

  let comData = [];

  let doctorData = [];
  if (JSON.stringify(patients) !== "{}" && JSON.stringify(patients)) {
    doctorData = patients.filter((item) => {
      return item.doctor_name === name;
    });
    comData = patients.filter((item) => item.status !== "COMPLETED");
  }
  const columns = [
    {
      name: "patient_name",
      label: "Patient Name",
      options: {
        filter: false,
        sort: true,
        customBodyRender: (value) => {
          return value === null ? "-" : value;
        },
      },
    },
    {
      name: "doctor_name",
      label: " Doctor Name",
      options: {
        filterType: "select",

        filter: true,
        sort: true,
        display: role.type === "authenticated" ? false : true,
        customBodyRender: (value) => {
          return value === null ? "-" : value;
        },
      },
    },
    {
      name: "date",
      label: "Date",
      options: {
        filter: true,
        sort: true,
        filterType: "select",
        customBodyRender: (value) => {
          return value === null
            ? "-"
            : new Date(value).toISOString().substring(0, 10);
        },
      },
    },
    {
      name: "exam",
      label: "Exam",
      options: {
        filterType: "select",
        filter: true,
        sort: false,
        customBodyRender: (value) => {
          return value === null ? "-" : value;
        },
      },
    },
    {
      name: "status",
      label: "Status",
      options: {
        filter: false,
        sort: false,
        customBodyRender: (value, tableMeta, updateValue) => {
          if (value) {
            switch (value) {
              case "CANCEL":
                return (
                  <Chip label="CANCELED" color="secondary" variant="outlined" />
                );
              case "COMPLETED":
                return (
                  <Chip label="COMPLETED" color="primary" variant="outlined" />
                );
              default:
                return (
                  <Chip label="PENDING" color="default" variant="outlined" />
                );
            }
          }
          return <Chip label="PENDING" color="default" variant="outlined" />;
        },
      },
    },
  ];

  const history = useHistory();
  const options = {
    filterType: "checkbox",
    selectableRows: false,
    onRowClick: (rowData, rowState) => {
      let _id = rowData[0].toLowerCase().replace(/\s/g, "");
      history.push({
        pathname: `/admin/details/${_id}`,
        state: {
          pname: rowData[0],
        },
      });
    },
  };
  return (
    <>
      <Header />
      {/* Page content */}
      <Container className="mt--7" fluid>
        {/* Table */}
        <Row>
          <div className="col">
            <MuiThemeProvider theme={getMuiTheme()}>
              <MUIDataTable
                title={"Pending Patients List"}
                data={role.type === "authenticated" ? doctorData : comData}
                columns={columns}
                options={options}
              />
            </MuiThemeProvider>
          </div>
        </Row>
      </Container>
    </>
  );
};

export default PendingTable;
